import { useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import Chat from '../chat/Chat'
import { AppStateContext } from '../../state/AppProvider'

const Personal = () => {
  const appStateContext = useContext(AppStateContext)

  useEffect(() => {
    if (appStateContext?.state.schoolAuth?.authenticated) {
      appStateContext.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: null })
    }
  }, [appStateContext?.state.schoolAuth?.authenticated])

  if (appStateContext?.state.authLoading) return null
  if (!appStateContext?.state.schoolAuth?.authenticated) return <Navigate to="/" replace />

  return <Chat personalMode />
}

export default Personal
